import { useMediaQuery, useTheme } from "@mui/material";
import { getButtonText } from "./modifyDayMealsButton-helpers";
export const useModifyDayMealsButton = ({ allowAdHocChanges, handleEditMealClick, meal, myMealsConfig, restrictAddRemoveDays, restrictMealQuantitySelection, selectedRecipes, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const btnTexts = (({ SkipMealsButtonText, AddMoreMealsButtonText, MealChangeQuantityButtonText, AddToOrderButtonText, }) => ({
        SkipMealsButtonText,
        AddMoreMealsButtonText,
        MealChangeQuantityButtonText,
        AddToOrderButtonText,
    }))(myMealsConfig);
    const buttonText = getButtonText(selectedRecipes, meal, allowAdHocChanges, restrictMealQuantitySelection, restrictAddRemoveDays, btnTexts);
    const handleClick = () => handleEditMealClick(meal);
    return { buttonText, handleClick, isMobile };
};
